import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "src/stores/RootStore";
import { AssignInvoiceToWorkflowUser } from "src/screens/creditors/creditor/details/actions/assignInvoice/AssignInvoiceToWorkflowUser";
import { WORKFLOWUSER_ROLE } from "src/stores/krediflow/InvoiceEnums";

interface InvoiceWorkflowUsersProps {
    type: "card" | "tab";
}

const InvoiceWorkflowUsersBase = (props: InvoiceWorkflowUsersProps) => {
    const { invoiceStore } = useContext(RootStoreContext);

    const { type } = props;

    const numberOfVisas = invoiceStore.currentInvoice?.numberOfVisas ?? 0;

    return (
        <>
            {Array.from({ length: numberOfVisas }).map((_, index) => {
                let workflowUserRole = WORKFLOWUSER_ROLE.VISA_1;

                const visaNumber = index + 1;

                switch (visaNumber) {
                    case 1:
                        workflowUserRole = WORKFLOWUSER_ROLE.VISA_1;
                        break;
                    case 2:
                        workflowUserRole = WORKFLOWUSER_ROLE.VISA_2;
                        break;
                    case 3:
                        workflowUserRole = WORKFLOWUSER_ROLE.VISA_3;
                        break;
                }

                return (
                    <AssignInvoiceToWorkflowUser
                        key={workflowUserRole.toString()}
                        workflowUserRole={workflowUserRole}
                        type={type}
                    />
                );
            })}
        </>
    );
};

export const InvoiceWorkflowUsers = Sentry.withProfiler(observer(InvoiceWorkflowUsersBase));
